import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LightningBolt } from "@/components/icons/LightningBolt";

/**
 * Suspense fallback for lazy routes.
 * Stays invisible for the first 280ms — most preloaded chunks resolve before that.
 * After the delay, fades in a row of staggered falling lightning bolts.
 */
const BOLT_LANES = [
  { left: "12%", size: 26, delay: 0.0 },
  { left: "28%", size: 32, delay: 0.12 },
  { left: "46%", size: 40, delay: 0.06 },
  { left: "62%", size: 30, delay: 0.18 },
  { left: "82%", size: 24, delay: 0.24 },
];

export const RouteFallback = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setShow(true), 280);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div className="fixed inset-0 bg-background overflow-hidden z-[150]">
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.25 }}
          className="absolute inset-0"
        >
          {BOLT_LANES.map((b, i) => (
            <motion.div
              key={i}
              initial={{ y: "-30vh", opacity: 0 }}
              animate={{
                y: "120vh",
                opacity: [0, 0.85, 0.85, 0],
              }}
              transition={{
                duration: 1.2,
                delay: b.delay,
                repeat: Infinity,
                repeatDelay: 0.2,
                ease: [0.4, 0, 0.6, 1],
                times: [0, 0.15, 0.85, 1],
              }}
              className="absolute"
              style={{ left: b.left }}
            >
              <div
                style={{
                  filter: "drop-shadow(0 0 12px hsl(var(--primary) / 0.6))",
                }}
              >
                <LightningBolt size={b.size} filled className="text-primary" />
              </div>
            </motion.div>
          ))}
        </motion.div>
      )}
    </div>
  );
};
